module.exports = __webpack_public_path__ + "img/aa.e836e661.png";